import { AztecProduct, BreadcrumbTrack } from 'types/models';
import {
  ChoiceGroupsModal,
  ParentProductInfo,
  PortionInfo,
  SelectPortionModal,
} from 'menu/components/MenuModal/ModalBody';
import { getSelectedPortion, portionHasChoices } from 'menu/utils';
import { CalorieAllowancePhrase } from 'menu/components/Calories';
import { MinimumAgeDisclaimer } from 'menu/components/MinimumAge';
import { SpecialRequestField } from 'menu/components/MenuModal/ModalComponents';
import { useConfig } from 'contexts/ConfigContext';

interface MenuModalBodyProps {
  aztecProduct: AztecProduct;
  updateAztecProduct: (product: AztecProduct) => void;
  updateBreadcrumbs: (breadcrumbs: BreadcrumbTrack[]) => void;
}

export const MenuModalBody: React.FC<MenuModalBodyProps> = ({
  aztecProduct,
  updateAztecProduct,
  updateBreadcrumbs,
}) => {
  const { specialRequestsDisabled } = useConfig();
  const andedUpsells = aztecProduct.andedUpsells;
  const selectedPortion = getSelectedPortion(aztecProduct);
  const minCustomerAge = aztecProduct.minimumCustomerAge;
  console.log({ aztecProduct });

  const workOutModalToShow = () => {
    if (selectedPortion) {
      // show choice modal - or selected portion info
      return portionHasChoices(selectedPortion) ||
        (andedUpsells && andedUpsells.length > 0) ? (
        <ChoiceGroupsModal
          aztecProduct={aztecProduct}
          updateAztecProduct={updateAztecProduct}
          updateBreadcrumbs={updateBreadcrumbs}
        />
      ) : (
        <PortionInfo portion={selectedPortion} isSelectedPortion />
      );
    } else {
      // This only shows when there is multiple portions
      return (
        <SelectPortionModal
          aztecProduct={aztecProduct}
          updateAztecProduct={updateAztecProduct}
        />
      );
    }
  };

  const modalToShow = workOutModalToShow();

  return (
    <div className="menu-modal-body">
      <div>
        <ParentProductInfo aztecProduct={aztecProduct} />
        {modalToShow}
      </div>
      <div className="menu-modal-instructions">
        {!specialRequestsDisabled && selectedPortion ? (
          <SpecialRequestField aztecProduct={aztecProduct} />
        ) : null}
        <div className="customer-disclaimers">
          {minCustomerAge ? (
            <MinimumAgeDisclaimer minAge={minCustomerAge} />
          ) : null}
          <CalorieAllowancePhrase />
        </div>
      </div>
    </div>
  );
};
